module.exports = __webpack_public_path__ + "static/img/ca.946c536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ca.png
// module id = 3Gg2
// module chunks = 192